// polyfill
import 'dom4';

// node modules
import PubSub from 'pubsub-js';

// constants
import { DOCUMENT_ELEMENT, SELECTORS } from '@/scripts/constants';

// components
import { HeroSlider, HistorySlider, NewsSlider, OtherItemsSlider } from '@/components/sliders';
import { MobileMenu } from '@/components/MobileMenu';
import { UltraHover } from '@/components/UltraHover';
import { initGoogleMaps } from '@/components/googleMaps/googleMaps';
import { Tabs } from '@/components/Tabs';
import { ClipImage } from '@/components/ClipImage';
import { preloader, PRELOADER_END } from '@/components/preloader';
import { scrollToTopScene } from '@/components/scrollToTop/scrollToTop';

// scrollmagic scenes
import { sticky } from '@/scrollmagic/scenes/sticky';
import { headerToggle } from '@/scrollmagic/scenes/header';

// utils
import '@/scripts/form-utils';
import '@/scripts/scrollmagic';
import '@/scripts/windowResize';
import '@/scripts/normalize';
import { isMobile } from '@/scripts/helper';

// assets
import '@/styles/main.scss';

// import '@/fonts';

// preloader
preloader();

document.addEventListener('DOMContentLoaded', () => {
  // init scroll-to-top
  scrollToTopScene();

  // init header toggle
  headerToggle();

  // init sliders
  document.querySelectorAll('[data-component="news-slider"]')
    .forEach((element) => {
      const swiper = new NewsSlider({ element });
      swiper.init();
    });

  document.querySelectorAll('[data-component="hero-slider"]')
    .forEach((element) => {
      const swiper = new HeroSlider({ element });
      swiper.init();
    });

  document.querySelectorAll('[data-component="other-items-slider"]')
    .forEach((element) => {
      const swiper = new OtherItemsSlider({ element });
      swiper.init();
    });

  document.querySelectorAll('[data-component="history-slider"]')
    .forEach((element) => {
      const swiper = new HistorySlider({ element });
      swiper.init();
    });

  // init mobile menu
  const menuElement = document.querySelector('[data-component="mobile-menu"]');
  if (menuElement) {
    const menu = new MobileMenu({
      element: menuElement,
      menuTriggers: document.querySelectorAll('[data-role="menu-trigger"]'),
      menuContent: menuElement.querySelector('[data-role="menu-content"]'),
      menuList: menuElement.querySelector('[data-role="menu-list"]'),
      innerLists: menuElement.querySelectorAll('[data-role="inner-menu-list"]'),
      innerTriggers: menuElement.querySelectorAll('[data-role="inner-menu-trigger"]'),
      innerTitle: menuElement.querySelector('[data-role="inner-menu-title"]'),
      initialState: {
        active: false,
        openedIndex: null,
      },
    });
    menu.init();
  }

  // tabs
  document.querySelectorAll('[data-component="tabs"]')
    .forEach((element) => {
      const tabs = new Tabs({
        element,
        links: element.querySelectorAll('[data-role="link"]'),
        content: element.querySelectorAll('[data-role="content"]'),
        initialState: {
          activeTab: 0,
        },
      });
      tabs.init();
    });

  // ultra hover
  document.querySelectorAll('[data-role="ultra-hover"]')
    .forEach(element => new UltraHover({ element }));

  // clip images
  document.querySelectorAll('[data-component="clip-image"]')
    .forEach((element) => {
      const clipImage = new ClipImage({
        element,
        trigger: element.querySelector('[data-role="trigger"]'),
        social: document.querySelector('[data-role="hero-social"]'),
        nav: document.querySelector('[data-role="hero-nav"]'),
        initialState: {
          svg: element.querySelector('[data-role="svg-circle"]'),
          image: element.querySelector('[data-role="svg-image"]'),
        },
      });
      clipImage.init();
    });

  // sticky scene
  sticky();

  // google maps
  document.querySelectorAll('[data-role="google-maps-container"]')
    .forEach(el => initGoogleMaps(el));

  // scroll-cta
  $('[data-role="scroll-cta"]').on('click', () => {
    $('html, body').stop().animate({ scrollTop: $('[data-role="scroll-to"]').offset().top - $('.header').height() });
  });

  // clickable card
  if (isMobile()) {
    document.querySelectorAll('[data-role="click-card"]').forEach((card) => {
      card.addEventListener('click', (e) => {
        if (e.target.closest('.button') && !card.classList.contains(SELECTORS.active)) {
          e.preventDefault();
        }
        card.classList.toggle(SELECTORS.active);
      });
      card.addEventListener('mouseleave', () => {
        card.classList.remove(SELECTORS.active);
      });
    });
  }

  // scroll scale
  if (document.querySelector('[data-role="scroll-scale"]')) {
    $(window).on('scroll', () => {
      const scroll = $(window).scrollTop();
      Array.from(document.querySelectorAll('[data-role="scroll-scale"]'))
        .forEach((el) => {
          const speed = el.dataset.speed || 0.05;
          el.style.transform = `translateZ(0) scale(${(100 + scroll * speed) / 100})`;
        });
    });
  }

  // fancybox
  $('[data-role="modal-button"]').fancybox();

  // lightgallery
  $('[data-role="gallery"]').lightGallery();

  if (DOCUMENT_ELEMENT.classList.contains('no-preloader')) {
    PubSub.publish(PRELOADER_END);
  }
});
